module.exports = __webpack_public_path__ + "media/images/logos/primary-bcs-fca372ea1a81c873c23cbdfce5b49aac.svg";